import { G } from "../../constants/theme";

export function Wrap({ children, style = {} }) {
  return (
    <div
      style={{
        maxWidth: 1140,
        margin: "0 auto",
        padding: "0 clamp(16px,4vw,44px)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function Sec({ children, bg = G.black, bt = true, style = {} }) {
  return (
    <div
      style={{
        background: bg,
        borderTop: bt ? `1px solid ${G.border}` : "none",
        padding: "clamp(44px,7vw,80px) 0",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
